import Home from '../views/home.vue';
import Login from '@/views/login.vue';
import notFound from '@/views/components/404page.vue';
import visitedForm from '../views/visitForm/visitedForm.vue';
import visitFormList from '../views/visitForm/visitFormList.vue';
import store from '@/store/index.js';
import ProjectFormList from '../views/project/projectList.vue';
import ProjectForm from '../views/project/projectForm.vue';
import UserSetup from '../views/user/userList.vue';
import Dashboard from '../views/dashboard.vue';
import PasswordRequest from '../views/user/passwordRequest.vue';
import UserRoles from '../views/user/userRoles.vue';
import ForgetPasswordRequest from '@/views/forgetPasswordRequest.vue';
// const Login = () => import('@/views/login.vue');
// const Home = () => import('@/views/home.vue');


export default [
    // 🔓 Login (PUBLIC)
    {
        path: '/login',
        component: Login,
        beforeEnter: (to, from, next) => {
            console.log('from: ', from);
            if (store?.state.userAuthenticated === true) {
                const path = from.path != 'login' ? from.fullPath : '/'
                next({ path });
            } else setTimeout(() => next(), 200);
        },
    },

    {
        path: '/forget-password-request-form',
        component: ForgetPasswordRequest,
        meta: {
            public: true,
            title: 'Forget Password Request Form',
            breadcrumb: 'Forget Password Request'
        },
    },

    // 🔓 Home layout (PUBLIC)
    {
        path: '/',
        component: Home,

        meta: {
            isEntryPoint: true,
            breadcrumb: 'Home'
        },

        beforeEnter: (to, from, next) => {
            if (store?.state.userAuthenticated === false) {
                setTimeout(() => next({ path: '/login' }), 200)
            } else next();
        },

        children: [

            // Dashboard
            {
                path: '/',
                component: Dashboard,

                meta: {
                    isEntryPoint: true,
                    breadcrumb: 'Dashboard'
                }
            },

            // Visit Form List
            {
                path: '/visit-form-list',
                component: visitFormList,

                meta: {
                    breadcrumb: 'Visits'
                },
            },

            // Visit Form
            {
                path: '/visit-form/:key',
                name: 'visitForm',
                props: true,
                component: visitedForm,

                meta: {
                    public: true,
                    title: 'Visit Form',
                    key: 'path',
                    breadcrumb: 'Visit Form'
                },
            },

            // Project Form
            {
                path: '/project-form/:key',
                name: 'projectForm',
                props: true,
                component: ProjectForm,

                meta: {
                    public: true,
                    title: 'Project Form',
                    key: 'path',
                    breadcrumb: 'Project Form'
                },
            },

            // Project List
            {
                path: '/project-list',
                component: ProjectFormList,

                meta: {
                    public: true,
                    title: 'Project List',
                    breadcrumb: 'Projects'
                },
            },

            // User Setup
            {
                path: '/user-setup',
                component: UserSetup,

                meta: {
                    public: true,
                    title: 'User Setup',
                    breadcrumb: 'User Setup'
                },
            },

            // Password Request
            {
                path: '/password-request',
                component: PasswordRequest,

                meta: {
                    public: true,
                    title: 'Password Request',
                    breadcrumb: 'Password Request'
                },
            },

            // User Role
            {
                path: '/user-role',
                component: UserRoles,

                meta: {
                    public: true,
                    title: 'User Role',
                    breadcrumb: 'User Role'
                },
            },
        ],
    },


    //   // 🔓 404 (PUBLIC)
    {
        path: '*',
        name: '404page',
        component: notFound,
        meta: {
            title: '404 - Not Found',
            public: true,
        },
    },


    // children: [
    //   ...RouterTabRoutes,

    //   // 🔓 Dashboard (PUBLIC)
    //   {
    //     path: '',
    //     component: Dashboard,
    //     meta: {
    //       title: 'Dashboard',
    //       closable: false,
    //       public: true
    //     }
    //   },

    //   // 🔒 PROTECTED ROUTES WITH MENU KEY

    //   {
    //     path: 'user',
    //     component: User,
    //     meta: {
    //       title: 'User',
    //       closable: true,

    //     }
    //   },
    //   {
    //     path: 'branch',
    //     component: Branch,
    //     meta: {
    //       title: 'Branch',
    //       closable: true,

    //     }
    //   },
    //   {
    //     path: 'user-allowed-branch',
    //     component: UserAllowedBranch,
    //     meta: {
    //       title: 'User Allowed Branch',
    //       closable: true,

    //     }
    //   },
    //   {
    //     path: 'sublocation',
    //     component: Sublocation,
    //     meta: {
    //       title: 'Sublocation',
    //       closable: true,

    //     }
    //   },
    //   {
    //     path: 'role',
    //     component: Role,
    //     meta: {
    //       title: 'Role',
    //       closable: true,

    //     }
    //   },
    //   {
    //     path: 'display-setup',
    //     component: Display,
    //     meta: {
    //       title: 'Display Setup',
    //       closable: true,

    //     }
    //   },
    //   {
    //     path: 'status',
    //     component: Status,
    //     meta: {
    //       title: 'Status',
    //       closable: true,

    //     }
    //   },
    //   {
    //     path: 'role-allowed-menu',
    //     component: RoleAllowedMenu,
    //     meta: {
    //       title: 'Role Allowed Menu',
    //       closable: true,

    //     }
    //   },
    //   {
    //     path: 'menu',
    //     component: Menu,
    //     meta: {
    //       title: 'Menu',
    //       closable: true,

    //     }
    //   },
    //     {
    //     path: 'visited-form',
    //     component: visitedForm,
    //     meta: {
    //       title: 'Visit Form',
    //       closable: true,

    //     }
    //   },

    // ]
];